import { ROUTES } from '@ab-core/functions';

export const searchInputFocusExceptions = [
    ROUTES.CART,
    ROUTES.CHECKOUT,
    ROUTES.CHECKOUT_OFFER,
    ROUTES.PRIVACY,
    ROUTES.NEWS,
    ROUTES.HELP,
    ROUTES.SIGNUP,
    ROUTES.SINGUPSUCCESS,
    ROUTES.NEWSLETTER,
    ROUTES.SERVICES,
    ROUTES.CALLBACK
];
